define('all/sliding-panel',['jquery', 'boxes/events/controller-event', 'all/slidingContentNavigation', 'all/hash-helper'], function ($, controllerEvent, slidingContentNavigation, hashHelper) {
    'use strict';

	var emptyOnPopState = function () {};
    var args;

    function showPanel(startFunction) {

        var $mainContentWrapper = $('#main-content-wrapper', parent.document.body),
            $slidingContentWrapper = $('#sliding-content-wrapper', parent.document.body),
            $mainHeader = $('#main-header', parent.document.body),
            defaultArgs = {
                startFunctionArgs: undefined,
                closePanelRedirectUrl: undefined,
                closeButtonScript: function ($controller) {
                    closePanel(args.closePanelRedirectUrl, $controller, slidingContentNavigation.goBackToPreviousHash);
                }
            };

        args = $.extend(defaultArgs, startFunction.args());
        $(document.body).css('overflow-x', 'hidden');
        $mainContentWrapper.removeClass('slide-up-content').addClass('slide-down-content');
        $slidingContentWrapper.removeClass('fade-out');
        $slidingContentWrapper.find('.close').show();

        $mainHeader.find('.header-content').removeClass('fade-in').addClass('ui-animation fade-out duration3');
        $mainHeader.parent().addClass('expanded');
        var $controller = startFunction.start();

        setTimeout(function () {
            $mainHeader.find('.header-content').hide();
            $slidingContentWrapper.find('.steps').show();
            $slidingContentWrapper.show();

        }, 300);

        setTimeout(function () {
            $mainContentWrapper.hide();


            hashHelper.setHashStateFunction(function () {
                // On popstate happens when user clicks back button and when hash change to a previously used one
                // When user clicks back button we have to make sure closePanel is called (could be same page on different paragraph).
                // On the other hand, if user clicked the close button we set an old hash, so popstate will happen,
                // and then it is important that we do not close panel twice (or worse, go to the redirect url again or so),
                // That is why popstate have to be set to empty function when we user have clicked the close button,
                // or when user pushed back button so that we not do things twice.
                closePanel(undefined, $controller);
            });


            var $closeButton = $slidingContentWrapper.find('.close, .middle.bar.signup');
            $closeButton.off('click').on('click', function (e) {
                e.preventDefault();
                hashHelper.setHashStateFunction(emptyOnPopState);
                $closeButton.off('click').on('click', function (e) {
                    // Do nothing on next click
                    e.preventDefault();
                });
                args.closeButtonScript($controller);
            });

        }, 800);
    }

    function closePanel(redirectUrl, $controller, whenDoneCallback) {
        hashHelper.setHashStateFunction(emptyOnPopState);
        var $mainContentWrapper = $('#main-content-wrapper', parent.document.body);
        var $slidingContentWrapper = $('#sliding-content-wrapper', parent.document.body);
        var $mainHeader = $('#main-header', parent.document.body);

        $slidingContentWrapper.addClass('ui-animation fade-out duration3');
        $('div.offer').removeClass('fade-in').addClass('fade-out');

        setTimeout(function () {
            $(document.body).css('overflow-x', 'auto');
            $mainHeader.find('.header-content').removeClass('fade-out').addClass('fade-in duration3').show();
            $mainHeader.parent().removeClass('expanded');
            $mainContentWrapper.css('display', 'block');
            $mainContentWrapper.removeClass('slide-down-content');
            $mainContentWrapper.addClass('slide-up-content');
            $slidingContentWrapper.children(':not(:last-child)').hide();
            $slidingContentWrapper.find('.steps .step').removeClass('done active');
            $slidingContentWrapper.find('.steps .step').first().addClass('active');
            $slidingContentWrapper.find('.middle.bar').hide();

            var $boxes = $slidingContentWrapper.find('.box');
            $boxes.hide();
            $boxes.removeClass('slide-in-left slide-in-right slide-out-left slide-out-right');
            $slidingContentWrapper.hide();
        }, 300);

        $controller.trigger(controllerEvent.RESET);

        // window.location.href !== redirectUrl
        if(typeof(redirectUrl) !== 'undefined' && redirectUrl !== null && window.top.location.href !== redirectUrl) {
            window.top.location.href = redirectUrl;
            window.top.location.reload();
        } else if(whenDoneCallback !== undefined) {
            whenDoneCallback();
        }
    }

    return {
        showPanel: showPanel,
        closePanel: closePanel
    };
});

